import TrackerBackend from './TrackerBackend';
import events from './events';

type IntercomMethod = 'trackEvent' | 'update';
type IntercomType = (
	method: IntercomMethod,
	eventOrProps?: string | Record<string, unknown>,
	args?: Record<string, unknown>
) => void;
type EventCategory = keyof typeof events;

const DEFAULT_EXCLUDED_CATEGORIES: EventCategory[] = [ 'subscription', 'workspace', 'onboardingThumbnails', 'access' ];

class IntercomTrackerBackend implements TrackerBackend {
	excludeCategories: EventCategory[] = [];

	initialize( excludeCategories: EventCategory[] = DEFAULT_EXCLUDED_CATEGORIES ) {
		this.excludeCategories = excludeCategories;
	}

	// User ID and properties are already set when initializing Intercom
	// in App.js
	setUserID() {}
	setSuperProperties() {}
	setUserProperties( properties: Record<string, unknown> ) {
		this.Intercom?.( 'update', properties );
	}

	trackLocation() {}
	trackPanel() {}

	trackEvent( args: { category: string, action: string, [key: string]: unknown } ) {
		if ( this.excludeCategories.includes( args.category as EventCategory ) ) {
			return;
		}

		this.Intercom?.( 'trackEvent', args.action, args );
	}

	private get Intercom(): IntercomType | undefined {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		return ( window as any ).Intercom;
	}
}

export default IntercomTrackerBackend;
